import axios from "axios";

import {
  TUTORIAL_API_ORIGIN,
} from "../config/tutorialConfig";

const publicTutorialApi = axios.create({
  baseURL: `${TUTORIAL_API_ORIGIN}/api/tutorials`,
  timeout: 15000,

  headers: {
    Accept: "application/json",
  },
});

/**
 * Charge le tutoriel publié depuis
 * l'application centrale MonAppliClub.
 *
 * Aucun token du site client n'est envoyé,
 * car il s'agit d'une route publique.
 */
export const getPublicTutorial = async ({
  appKey = "monappli-club",
  siteKey = "",
  locale = "fr-FR",
  role = null,
  version = null,
  signal,
} = {}) => {
  const params = {
    app_key: appKey,
    locale,
  };

  if (siteKey) {
    params.site_key = siteKey;
  }

  if (role) {
    params.role = role;
  }

  if (version) {
    params.version = version;
  }

  const response =
    await publicTutorialApi.get(
      "/public",
      {
        params,
        signal,
      }
    );

  if (
    !response.data ||
    !response.data.tutorial
  ) {
    throw new Error(
      "La réponse du tutoriel est invalide."
    );
  }

  return response.data;
};

/**
 * Transforme une erreur Axios en message
 * compréhensible pour l'utilisateur.
 */
export const getPublicTutorialErrorMessage = (
  error
) => {
  if (
    error?.code === "ERR_CANCELED" ||
    axios.isCancel(error)
  ) {
    return null;
  }

  if (!error?.response) {
    return (
      "Impossible de contacter le service " +
      "des tutoriels. Vérifiez votre connexion."
    );
  }

  if (error.response.status === 404) {
    return (
      "Aucun tutoriel n’est actuellement " +
      "disponible pour cette application."
    );
  }

  if (error.response.status >= 500) {
    return (
      "Le service des tutoriels est " +
      "temporairement indisponible."
    );
  }

  return (
    error.response.data?.message ||
    "Impossible de charger le tutoriel."
  );
};

export default publicTutorialApi;